/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import ds, { media } from 'designsystem';
import { Row, Column } from 'hedron';
import styled from 'styled-components';
import CalculatorInput from 'kentico-blocks/Calculator/CalculatorInputRow/CalculatorInput';

const Icon = styled.img`
  position: absolute;
  opacity: 0.35;
  transform: translateX(calc(50vw - 75%));
  width: ${ds.get('metrics.xl')};
  margin-top: ${ds.get('metrics.xs')};

  ${media.tablet`
     opacity: 1;
     transform: none;
  `}
`;

const NoPaddingColumn = styled(Column)`
  padding-left: 0;
  padding-right: 0;
`;

const InputsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 3px solid gray;
  padding-bottom: ${ds.get('metrics.xs')};
  
  ${({ short }) => (short ? 'width: 135px;' : '')}
      
  ${media.tablet`
    ${({ short }) => (short ? 'width: 165px;' : '')}
  `}
`;

@observer
export default class CalculatorInputRow extends Component {
  render() {
    const {
      firstInputLabel,
      secondInputLabel,
      firstValueObservableBox,
      secondValueObservableBox,
      icon,
      currency,
    } = this.props;

    return (
      <Row>
        <NoPaddingColumn md={3}>
          <Icon
            src={icon}
            alt={firstInputLabel}
          />
        </NoPaddingColumn>
        <NoPaddingColumn md={9} lg={7}>
          <InputsContainer short={!secondValueObservableBox && !secondInputLabel}>
            <CalculatorInput
              label={firstInputLabel}
              valueObservableBox={firstValueObservableBox}
              hasButtons
              noNegative
            />
            {
              secondInputLabel && (
                <CalculatorInput
                  label={secondInputLabel}
                  labelRight
                  valueObservableBox={secondValueObservableBox}
                  currency={currency}
                  noNegative
                />
              )}
          </InputsContainer>
        </NoPaddingColumn>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/kentico-blocks/Calculator/CalculatorInputRow/index.jsx